<mat-dialog-content>
    <div class="dialog-content text-center">
        <!-- Success State -->
        <ng-container>
            <img src="./assets/images/info-icon-red-outline.svg" alt="info" class="status-icon" />
            <h2 class="text-danger">Session Expired</h2>
        </ng-container>

        <p class="message">You have been logged out due to inactivity.<br> Please login again.</p>

        <button mat-raised-button color="primary" type="button" mat-dialog-close class="mt-3" (click)="loginAgain()">
            Login Again
        </button>
    </div>
</mat-dialog-content>